import React, { useState, useRef, useEffect } from 'react'
import PageHeader from '../../Components/PageHeader/PageHeader'
import { hasError } from '../../utils'
import { BadgeRussianRuble, BrickWallIcon, BuildingIcon } from 'lucide-react'
import AppInput from '../../Components/AppInput/AppInput';
import { useDispatch, useSelector } from 'react-redux';
import AppButton from '../../Components/AppButton/AppButton';
import { AccountValidationScheema } from '../../ValidationScheema/AccountValidation';
import { setApiErrorJson } from '../../Redux/Actions/ApiAction';
import { addAccount, updateAccount } from '../../Constant/Constant';
import { ApiHit } from '../../Api/ApiHit';
import toast from 'react-hot-toast';
import { genderOptions, statusOptions } from '../../Constant/Options';
import AppSelect from '../../Components/AppSelect/AppSelect';

function AddAccount({ isEditMode, onClose }) {
  const [submitLoading, setSubmitLoading] = useState(false);
  const ApiReducer = useSelector((state) => state.ApiReducer);
  const dispatch = useDispatch();
  const originalDataRef = useRef(null);

  // Store original 
  useEffect(() => {
    if (isEditMode && ApiReducer?.apiJson) {
      originalDataRef.current = { ...ApiReducer.apiJson };
    }
  }, []);



const handleSubmit = () => {
  setSubmitLoading(true);
  AccountValidationScheema(ApiReducer?.apiJson, isEditMode).then((error) => {
    dispatch(setApiErrorJson(error))
    if (Object.keys(error).length === 0) {
      const apiEndpoint = isEditMode ? updateAccount : addAccount;

      let apiData;

      if (isEditMode) {
        // For update: only send changed fields + _id
        const changedFields = { _id: ApiReducer?.apiJson?._id };

        Object.keys(ApiReducer?.apiJson).forEach((key) => {
          if (key !== '_id' && key !== '__v' && key !== 'createdAt' && key !== 'updatedAt') {
            const currentValue = ApiReducer?.apiJson[key];
            const originalValue = originalDataRef.current?.[key];

            // Check if value has changed
            if (currentValue !== originalValue) {
              // Convert status to boolean if needed
              if (key === 'status') {
                changedFields[key] = currentValue === "true" || currentValue === true ? true : false;
              } else {
                changedFields[key] = currentValue;
              }
            }
          }
        });

        apiData = changedFields;
      } else {
        // For add: send all data
        apiData = {
          ...ApiReducer?.apiJson,
          status:
            ApiReducer?.apiJson?.status === "true" ||
            ApiReducer?.apiJson?.status === true
              ? true
              : false,
        };
      }

      ApiHit(apiData, apiEndpoint)
        .then((res) => {
          console.log("res", res);
          const successCode = isEditMode ? 200 : 201;
          if (res?.statusCode === successCode) {
            toast.success(
              isEditMode
                ? "Account updated successfully"
                : "Account added successfully"
            );
            onClose();
          } else {
            toast.error(res?.error || "Something went wrong");
          }
        })
        .finally(() => {
          setSubmitLoading(false);
        });
    } else {
      setSubmitLoading(false);
    }
  });
};


  return (
    <div className='p-5'>
      <PageHeader
        title={isEditMode ? 'Edit Account' : 'Add Account'}
        description={isEditMode ? 'Update account information and account details' : 'Create a new account and manage'}
      />
      <div >
        <AppInput
          title="Account Name"
          placeholder="Enter account name"
          name="accountName"
          important={true}
          error={hasError('accountName', ApiReducer)}
          icon={<BuildingIcon size={18} />}
          disabled={submitLoading}
        />

        <AppSelect
          title="Status"
          name="status"
          options={statusOptions}
          placeholder="Select status"
          disabled={submitLoading}
          error={hasError('status', ApiReducer)}

        />



      </div>

      <div className='mt-5 flex justify-end'>
        <AppButton
          buttontext={submitLoading ? "Processing..." : (isEditMode ? "Update Acccount" : "Add Account")}
          onClick={handleSubmit}
          disabled={submitLoading}
        />
      </div>
    </div>
  )
}

export default AddAccount
